import React from 'react';
import { SVGProps } from './type';

export const IconExpenseAnalytics = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M11.5 7.32464C8.27834 7.32464 5.66667 9.93631 5.66667 13.158C5.66667 16.3796 8.27834 18.9913 11.5 18.9913C14.1769 18.9913 16.4916 17.1726 17.1495 14.6173C17.2643 14.1716 17.7186 13.9033 18.1643 14.0181C18.61 14.1328 18.8783 14.5872 18.7635 15.0329C17.9172 18.3202 14.9419 20.658 11.5 20.658C7.35786 20.658 4 17.3001 4 13.158C4 9.01584 7.35786 5.65798 11.5 5.65798V5.25003C11.5 4.55966 12.0596 4 12.75 4C12.7764 4.00019 12.7764 4.00019 12.8028 4.00112C15.0303 4.09527 16.89 4.86951 18.3393 6.31872C19.7885 7.76792 20.5627 9.62761 20.6568 11.8548C20.6862 12.5447 20.1506 13.1277 19.4608 13.1569C19.4344 13.1578 19.4344 13.1578 19.408 13.158H12.75C12.0596 13.158 11.5 12.5983 11.5 11.908V7.32464ZM13.1667 11.4913H18.9626C18.8129 9.87038 18.2136 8.55008 17.1607 7.49723C16.1079 6.44439 14.7876 5.84508 13.1667 5.69535V11.4913Z"
      fill={fill}
    />
  </g>
);
